/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DecisionEnum } from './DecisionEnum';
import {
    DecisionEnumFromJSON,
    DecisionEnumFromJSONTyped,
    DecisionEnumToJSON,
    DecisionEnumToJSONTyped,
} from './DecisionEnum';

/**
 * 
 * @export
 * @interface BulkUpdateUnmatchedDataPointsRequest
 */
export interface BulkUpdateUnmatchedDataPointsRequest {
    /**
     * 
     * @type {DecisionEnum}
     * @memberof BulkUpdateUnmatchedDataPointsRequest
     */
    decision: DecisionEnum;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateUnmatchedDataPointsRequest
     */
    site?: string;
}



/**
 * Check if a given object implements the BulkUpdateUnmatchedDataPointsRequest interface.
 */
export function instanceOfBulkUpdateUnmatchedDataPointsRequest(value: object): value is BulkUpdateUnmatchedDataPointsRequest {
    if (!('decision' in value) || value['decision'] === undefined) return false;
    return true;
}

export function BulkUpdateUnmatchedDataPointsRequestFromJSON(json: any): BulkUpdateUnmatchedDataPointsRequest {
    return BulkUpdateUnmatchedDataPointsRequestFromJSONTyped(json, false);
}

export function BulkUpdateUnmatchedDataPointsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateUnmatchedDataPointsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'decision': DecisionEnumFromJSON(json['decision']),
        'site': json['site'] == null ? undefined : json['site'],
    };
}

export function BulkUpdateUnmatchedDataPointsRequestToJSON(json: any): BulkUpdateUnmatchedDataPointsRequest {
    return BulkUpdateUnmatchedDataPointsRequestToJSONTyped(json, false);
}

export function BulkUpdateUnmatchedDataPointsRequestToJSONTyped(value?: BulkUpdateUnmatchedDataPointsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'decision': DecisionEnumToJSON(value['decision']),
        'site': value['site'],
    };
}

